import { lazyLoadImages } from "../imageLazyLoader";
import { registerVisibilityTrackers } from "../utils/visibilityTracker";
import { registerAppLinkListeners } from "../utils/appInstallLinkMetrics";

export function prepareFooter() {
  lazyLoadImages();
  registerVisibilityTrackers();
  registerAppLinkListeners();
}
